import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { clientService } from "../../../Services/client.service";

// Aba "Configurações" do cliente — campos vêm do próprio GET
// /customers/{id} (Authorize*). Mapeamento de "eventsByPhone" para
// AuthorizeWhatsapp é uma suposição (não achamos campo específico de
// "aviso por telefone" no schema) — confirmar com o backend.
export default function Settings({ clientId }) {
  const { t } = useTranslation();

  const [settings, setSettings] = useState({
    eventsByPhone: false,
    billingEmailAlert: false,
    billingSmsAlert: false,
    autoRestriction: false,
    authorizeNegativation: false,
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function loadSettings() {
      if (!clientId) return;
      const client = await clientService.fetchClient(clientId);
      if (!isMounted || !client) return;

      setSettings({
        eventsByPhone: Boolean(client.authorizeWhatsapp),
        billingEmailAlert: Boolean(client.authorizeEmail),
        billingSmsAlert: Boolean(client.authorizeSms),
        autoRestriction: Boolean(client.authorizeAutomaticRestriction),
        authorizeNegativation: Boolean(client.authorizeNegativeListing),
      });
    }

    loadSettings();
    return () => {
      isMounted = false;
    };
  }, [clientId]);

  const toggle = (field) => {
    setSettings((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      // Mesmo risco de payload parcial mencionado em Notes.jsx.
      await clientService.updateClient(clientId, {
        AuthorizeWhatsapp: settings.eventsByPhone,
        AuthorizeEmail: settings.billingEmailAlert,
        AuthorizeSms: settings.billingSmsAlert,
        AuthorizeAutomaticRestriction: settings.autoRestriction,
        AuthorizeNegativeListing: settings.authorizeNegativation,
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="p-3">
      {/* Sistema */}
      <div className="mb-4">
        <div className="bg-primary text-white px-3 py-2 mb-3">
          {t("CUSTOMER.SETTINGS.SYSTEM_TITLE")}
        </div>

        <div className="form-check mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="settings-events-by-phone"
            checked={settings.eventsByPhone}
            onChange={() => toggle("eventsByPhone")}
          />
          <label
            className="form-check-label"
            htmlFor="settings-events-by-phone"
          >
            {t("CUSTOMER.SETTINGS.EVENTS_BY_PHONE")}
          </label>
        </div>
      </div>

      {/* Cobrança */}
      <div className="mb-4">
        <div className="bg-primary text-white px-3 py-2 mb-3">
          {t("CUSTOMER.SETTINGS.BILLING_TITLE")}
        </div>

        <div className="form-check mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="settings-billing-email-alert"
            checked={settings.billingEmailAlert}
            onChange={() => toggle("billingEmailAlert")}
          />
          <label
            className="form-check-label"
            htmlFor="settings-billing-email-alert"
          >
            {t("CUSTOMER.SETTINGS.BILLING_EMAIL_ALERT")}
          </label>
        </div>

        <div className="form-check mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="settings-billing-sms-alert"
            checked={settings.billingSmsAlert}
            onChange={() => toggle("billingSmsAlert")}
          />
          <label
            className="form-check-label"
            htmlFor="settings-billing-sms-alert"
          >
            {t("CUSTOMER.SETTINGS.BILLING_SMS_ALERT")}
          </label>
        </div>

        <div className="form-check mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="settings-auto-restriction"
            checked={settings.autoRestriction}
            onChange={() => toggle("autoRestriction")}
          />
          <label
            className="form-check-label"
            htmlFor="settings-auto-restriction"
          >
            {t("CUSTOMER.SETTINGS.AUTO_RESTRICTION")}
          </label>
        </div>

        <div className="form-check mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="settings-authorize-negativation"
            checked={settings.authorizeNegativation}
            onChange={() => toggle("authorizeNegativation")}
          />
          <label
            className="form-check-label"
            htmlFor="settings-authorize-negativation"
          >
            {t("CUSTOMER.SETTINGS.AUTHORIZE_NEGATIVATION")}
          </label>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button type="button" className="btn btn-primary" onClick={handleSave} disabled={isSaving}>
          {t("CUSTOMER.SETTINGS.SAVE")}
        </button>
      </div>
    </div>
  );
}
